export default "__VITE_ASSET__CpMw5xRC__"